import {IconButton} from '@wandb/components';
import React, {useCallback} from 'react';

import {useWorkspaceDrawerContext} from '../../WorkspaceDrawerContextProvider';

export const CloseButton = () => {
  const {closeWorkspaceDrawer} = useWorkspaceDrawerContext();
  const onClose = useCallback(
    () => closeWorkspaceDrawer(),
    [closeWorkspaceDrawer]
  );

  return (
    <IconButton
      variant="ghost"
      icon="close"
      onClick={onClose}
      aria-label="Close workspace drawer"
    />
  );
};
